import script from "./HelloWorldComposition.vue?vue&type=script&lang=tsx"
export * from "./HelloWorldComposition.vue?vue&type=script&lang=tsx"

const cssModules = script.__cssModules = {}
import style0 from "./HelloWorldComposition.vue?vue&type=style&index=0&id=2ad7648c&lang=sass&module=true"
cssModules["$style"] = style0

export default script